export const join = (...paths: string[]): string => {
    if (paths.length === 0) {
        return '';
    }
    if (paths.length === 1) {
        return paths[0];
    }
    if (paths.length === 2) {
        const [p1, p2] = paths;
        const p1Suffix = p1.endsWith('/') ? '' : '/';
        return `${p1}${p1Suffix}${p2.replace(/^(\/)+/, '')}`;
    }
    const ml: number = Math.trunc(paths.length / 2);
    const m1: string[] = paths.slice(0, ml);
    const m2: string[] = paths.slice(ml);
    const p1: string = join(...m1);
    const p2: string = join(...m2);
    return join(p1, p2);
};
